import './divider.scss';

import PropTypes from 'prop-types';
import React from 'react';

const Divider = ({ text }) => {
  return (
    <div className="divider">
      <span className="divider__line" />
      {text && <span className="divider__text">{text}</span>}
      <span className="divider__line" />
    </div>
  );
};

Divider.propTypes = {
  text: PropTypes.string
};

export { Divider };
